import React from 'react';
import { ExtendedContentContainer, ExtendedContentType } from 'components/ExtendedContent/ExtendedContentContainer';
import WordGlyph from 'components/WordGlyph';

export const WordGlyphModalComponent = ({ wordGridResource, defaultWord }) => {
  return <ExtendedContentContainer extendedContentType={ExtendedContentType.WordGlyph}>
    <WordGlyph dataList={wordGridResource} defaultWord={defaultWord} />
  </ExtendedContentContainer>
};
